import React from 'react'
import PropTypes from 'prop-types'
import { isInvestor } from '../../../global/authentication/authentication-manager.js'
import {
  FUTURE_SCHOLAR_529,
  VARIABLE_FUND,
  CLOSED_END_FUND,
  INTERVAL_FUND,
} from '../Helpers/FundTypes.js'
import { formatDateStandard } from '../../../global/formatters/string-formatter.js'
import {
  getTooltipContentByKey,
  getVariablePortfolioTooltipContent,
} from '../../Tooltip/tooltipUtil.js'
import Tooltip from '../../Tooltip/Tooltip.jsx'
import { getRelativeBasePath } from '../../../global/environments/path.js'

function FeesExpenses({ fund, feesAndExpenses }) {
  const variablePortfolioTooltipData = getVariablePortfolioTooltipContent()

  return (
    <section
      className="section-content u-adel-reset"
      data-section-content="fees-expenses"
      id="fees-expenses"
    >
      <div className="u-sizeConstrained">
        <hr className="Rule Rule--thin Module-divider" role="presentation" />
        <div className="u-paddingVert12gu">
          <h2 className="u-marginBottom6gu">Fees &amp; Expenses</h2>
          <div id="operating-expenses">
            <div className="Grid Grid--fill Grid--withGutter Grid Grid--fill Grid--withGutter">
              <div className="Grid Grid--alignBottom Grid--fill Grid--withGutter u-size6of12">
                <h3 className="u-flexAuto u-sizeFull u-marginTop0 u-marginBottom3gu">
                  Annual Operating Expenses{' '}
                  <span className="u-sm-block u-sm-paddingTop1gu u-textSecondary u-textNormal u-textColorLight">
                    as of {formatDateStandard(feesAndExpenses.expenseAsOfDate)}
                  </span>
                </h3>
                <div className="u-sm-posRelative">
                  <Tooltip
                    heading={
                      getTooltipContentByKey(
                        variablePortfolioTooltipData,
                        'Net Expense Ratio'
                      )?.heading || 'Net Expense Ratio'
                    }
                    content={
                      getTooltipContentByKey(
                        variablePortfolioTooltipData,
                        'Net Expense Ratio'
                      )?.content || ''
                    }
                    direction="Tooltip-left"
                    id="net-expense-ratio-info"
                  >
                    <p className="u-textColorLight u-textSecondary u-textSolid u-marginBottom0">
                      <span className="u-textColorLight u-textSecondary Tooltip-label">
                        Net Expense Ratio
                      </span>
                      <span className="Icon--material Tooltip-icon u-marginLeft1gu">
                        info
                      </span>
                    </p>
                  </Tooltip>
                  {feesAndExpenses.expenseNet && (
                    <p className="u-textSizeMsrp3 u-textSecondary u-sm-textSizeMsrp1">
                      {feesAndExpenses.expenseNet}%
                    </p>
                  )}
                  {feesAndExpenses.cappedExpense && (
                    <p className="u-textSizeMsrp3 u-textSecondary u-sm-textSizeMsrp1">
                      {feesAndExpenses.cappedExpense}%
                    </p>
                  )}
                </div>
                <div className="u-sm-posRelative">
                  <Tooltip
                    heading={
                      getTooltipContentByKey(
                        variablePortfolioTooltipData,
                        'Gross Expense Ratio'
                      )?.heading || 'Gross Expense Ratio'
                    }
                    content={
                      getTooltipContentByKey(
                        variablePortfolioTooltipData,
                        'Gross Expense Ratio'
                      )?.content || ''
                    }
                    direction="Tooltip-left"
                    id="gross-expense-ratio-info"
                  >
                    <p className="u-textColorLight u-textSecondary u-textSolid u-marginBottom0">
                      <span className="u-textColorLight u-textSecondary Tooltip-label">
                        Gross Expense Ratio
                      </span>
                      <span className="Icon--material Tooltip-icon u-marginLeft1gu">
                        info
                      </span>
                    </p>
                  </Tooltip>
                  {/* <p className="u-textColorLight u-textSecondary u-textSolid u-marginBottom0">
                    Gross Expense Ratio
                  </p> */}
                  {feesAndExpenses.grossExpense && (
                    <p className="u-textSizeMsrp3 u-textSecondary u-sm-textSizeMsrp1">
                      {feesAndExpenses.grossExpense}%
                    </p>
                  )}
                </div>
                <div className="u-sm-posRelative">
                  {feesAndExpenses.expenseRatioWaiverDate && (
                    <div>
                      <p className="u-textColorLight u-textSecondary u-textSolid u-marginBottom0">
                        <span className="u-textColorLight u-textSecondary">
                          Waiver Expiration Date
                        </span>
                      </p>
                      <p className="u-textSizeMsrp3 u-textSecondary u-sm-textSizeMsrp1">
                        {formatDateStandard(
                          feesAndExpenses.expenseRatioWaiverDate
                        )}
                      </p>
                    </div>
                  )}
                </div>
              </div>
              {fund.fundGroup !== VARIABLE_FUND &&
                fund.fundGroup !== FUTURE_SCHOLAR_529 &&
                fund.fundGroup !== CLOSED_END_FUND &&
                fund.fundGroup !== INTERVAL_FUND && (
                  <div className="Grid Grid--fill u-size6of12">
                    <div className="Grid Grid--alignBottom Grid--fill Grid--withGutter">
                      <h3 className="u-flexAuto u-sizeFull u-marginTop0 u-marginBottom3gu">
                        Sales Charges
                      </h3>
                      <div>
                        <p className="u-textColorLight u-textSecondary u-textSolid u-marginBottom0">
                          Max. Sales Charge or CDSC
                        </p>
                        {feesAndExpenses.maxSalesCharge && (
                          <p className="u-textSizeMsrp3 u-textSecondary u-sm-textSizeMsrp1">
                            {feesAndExpenses.maxSalesCharge}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="Grid Grid--alignTop Grid--fill">
                      {!isInvestor() &&
                        fund.fundGroup !== FUTURE_SCHOLAR_529 && (
                          <a
                            className="u-paddingTop1gu u-textNormal u-textSolid u-textSecondary"
                            target="_blank"
                            href={
                              getRelativeBasePath() +
                              '/binaries/content/assets/cti/public/sales_charge_commission_schedule.pdf'
                            }
                            rel="noreferrer"
                          >
                            Sales Charge / Commission Schedule (PDF)
                          </a>
                        )}
                    </div>
                  </div>
                )}
            </div>
            <div className="disclaimer u-marginTop4gu">
              <a
                className="u-textNormal u-textSolid u-textSecondary"
                href="#expenseRatio-disclosures"
              >
                View disclosures
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

FeesExpenses.propTypes = {
  fund: PropTypes.object,
  feesAndExpenses: PropTypes.object,
}

export default FeesExpenses
